import _typeof from '../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/typeof.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.constructor.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.for.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.key-for.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.json.stringify.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.get-own-property-symbols.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.description.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.some.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.function.name.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import { __assign, __spreadArray } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import { isBoolean, isString, isFunction } from 'lodash';
import { Field } from 'rc-field-form';
import React, { useContext, useEffect, useMemo } from 'react';
import './index.less.js';
import classNames from 'classnames';
import { attachControlToProps } from '../../utils/attachControlToProps.js';
import { StepFormContext } from '../../TiStepsForm/context/index.js';
import getFieldId from '../common/getFieldId.js';
import FormContext from '../context/FormContext.js';
import { toArray } from '../../utils/toArray.js';
import Label from './Label.js';
import Error from './Error.js';
import Description from './Description.js';

var TiFormItem = function TiFormItem(props) {
  var fieldName = props.name,
    label = props.label,
    _a = props.rules,
    rules = _a === void 0 ? [] : _a,
    shouldUpdate = props.shouldUpdate,
    dependencies = props.dependencies,
    _b = props.trigger,
    trigger = _b === void 0 ? 'onChange' : _b,
    _c = props.validateTrigger,
    validateTrigger = _c === void 0 ? trigger : _c,
    children = props.children,
    _d = props.direction,
    direction = _d === void 0 ? 'horizontal' : _d,
    description = props.description,
    _e = props.noStyle,
    noStyle = _e === void 0 ? false : _e,
    _f = props.border,
    border = _f === void 0 ? true : _f,
    subscribe = props.subscribe,
    required = props.required;
  var _g = useContext(FormContext),
    formName = _g.name,
    formPubSub = _g.pubSub,
    formContext = _g.context;
  var _h = useContext(StepFormContext),
    stepFormName = _h.name,
    registerStepFormField = _h.registerStepFormField,
    unregisterStepFormField = _h.unregisterStepFormField;
  useEffect(function () {
    if (stepFormName) {
      registerStepFormField(stepFormName, fieldName);
    }
    return function () {
      if (stepFormName) {
        unregisterStepFormField(stepFormName, fieldName);
      }
    };
  }, []);
  var isRequired = useMemo(function () {
    return isBoolean(required) ? required : rules.some(function (rule) {
      return _typeof(rule) === 'object' && rule.required;
    });
  }, [rules, required]);
  var labelNode = useMemo(function () {
    if (!label) {
      return undefined;
    }
    return /*#__PURE__*/React.createElement(Label, {
      title: label,
      isRequired: isRequired
    });
  }, [label, isRequired]);
  var descriptionNode = useMemo(function () {
    if (!description) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Description, {
      title: description
    });
  }, [description]);
  var renderLayout = function renderLayout(fieldChilren, meta) {
    var fieldId = getFieldId(fieldName, formName);
    var formItemCls = classNames({
      'ti-form-item': true,
      'ti-form-item-empty-label': !labelNode
    });
    var contentCls = classNames({
      'ti-form-item-content': true,
      'ti-form-item-border': border
    });
    var directionCls = classNames({
      'ti-form-item-vertical': direction === 'vertical',
      'ti-form-item-horizontal': direction === 'horizontal'
    });
    if (noStyle) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, fieldChilren);
    }
    if (direction === 'custom') {
      return /*#__PURE__*/React.createElement("div", {
        className: formItemCls,
        id: fieldId
      }, /*#__PURE__*/React.createElement("div", {
        className: contentCls
      }, fieldChilren));
    }
    if (direction === 'vertical') {
      return /*#__PURE__*/React.createElement("div", {
        className: formItemCls,
        id: fieldId
      }, /*#__PURE__*/React.createElement("div", {
        className: contentCls
      }, /*#__PURE__*/React.createElement("div", {
        className: directionCls
      }, meta === null || meta === void 0 ? void 0 : meta.labelNode, meta === null || meta === void 0 ? void 0 : meta.descriptionNode, /*#__PURE__*/React.createElement("div", {
        className: "ti-form-item-field"
      }, fieldChilren)), meta === null || meta === void 0 ? void 0 : meta.errorNode));
    }
    if (direction === 'horizontal') {
      return /*#__PURE__*/React.createElement("div", {
        className: formItemCls,
        id: fieldId
      }, /*#__PURE__*/React.createElement("div", {
        className: contentCls
      }, /*#__PURE__*/React.createElement("div", {
        className: directionCls
      }, meta === null || meta === void 0 ? void 0 : meta.labelNode, /*#__PURE__*/React.createElement("div", {
        className: "ti-form-item-field"
      }, fieldChilren)), meta === null || meta === void 0 ? void 0 : meta.descriptionNode, meta === null || meta === void 0 ? void 0 : meta.errorNode));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  return /*#__PURE__*/React.createElement(Field, {
    name: fieldName,
    shouldUpdate: shouldUpdate,
    dependencies: dependencies,
    rules: rules,
    trigger: trigger,
    validateTrigger: validateTrigger
  }, function (control, meta) {
    var errors = meta.errors;
    var childProps = null;
    var childNode = null;
    var fieldMeta = {
      errorNode: /*#__PURE__*/React.createElement(Error, {
        errors: errors
      }),
      labelNode: labelNode,
      descriptionNode: descriptionNode
    };
    var controlPlus = __assign(__assign({}, control), {
      onChange: function onChange(args) {
        control.onChange(args);
        if (isString(subscribe)) {
          formPubSub === null || formPubSub === void 0 ? void 0 : formPubSub.publish({
            target: subscribe,
            event: 'onChange'
          });
        }
      }
    });
    if ( /*#__PURE__*/React.isValidElement(children)) {
      childProps = attachControlToProps(children, __spreadArray(__spreadArray([], toArray(trigger), true), toArray(validateTrigger), true), controlPlus);
      childNode = /*#__PURE__*/React.cloneElement(children, __assign(__assign({}, childProps), {
        meta: fieldMeta
      }));
    } else if (isFunction(children)) {
      var node = children(formContext);
      childProps = attachControlToProps(node, __spreadArray(__spreadArray([], toArray(trigger), true), toArray(validateTrigger), true), controlPlus);
      childNode = /*#__PURE__*/React.cloneElement(node, __assign(__assign({}, childProps), {
        meta: fieldMeta
      }));
    } else {
      console.warn('InValid React childrenNode');
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return renderLayout(childNode, fieldMeta);
  });
};

export { TiFormItem as default };
